import store from '@/store'

export default async (to, from, next) => {
  if (!store.getters['auth/check']) {
    window.location.href = `/signin?redirect=${encodeURIComponent(to.fullPath)}`
  } else {
    next()
  }
}
